module.exports = __webpack_public_path__ + "img/dreams-mini-landscape.d9f3db8.png";